module.exports = __webpack_public_path__ + "img/arrow-left-short.03637750.svg";